import React from "react";
import Spin from "react-reveal/Spin";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import brands data
import { brands } from "../data";

const Brands = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="bg-tertiary py-12">
      <div className="container mx-auto">
        <div>
          <Slider {...settings}>
            {brands.map((skill, index) => (
              <div className="flex justify-center items-center" key={index}>
                <Spin>
                  <img className="hover:cursor-grap" src={skill.img} alt="" />
                </Spin>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Brands;
